import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';


import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import DropDownList from '../DropDownList';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputComponent from '../InputComponent';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DialogTitle from '@material-ui/core/DialogTitle';

import { buildUIStringArray } from '../../utils/index';

import languages from '../../utils/languages';

import { pdfCreateCancel, pdfCreate } from '../../modules/app';
import { adobeCancelSavePDF, adobeSavePDF } from '../../utils/analytics';

class PrintPdfDialog extends React.Component {

  state = {
    nameCB: false,
    dateCB: false,
    timeCB: false,
    printAllCB: false,
    printProjectsCB: false,
    pdfName: '',
    pdfDate: '',
    pdfTime: '',
    selectedLanguage: 'English',
    calculationStatus: [],
  }

  initLanguage = (value) => {
    this.state.selectedLanguage = value;
  }

  onNameCheckboxChange = (event) => {
    this.setState({nameCB: !this.state.nameCB});
  }
  onDateCheckboxChange = (event) => {
    this.setState({dateCB: !this.state.dateCB});
  }
  onTimeCheckboxChange = (event) => {
    this.setState({timeCB: !this.state.timeCB});
  }
  onPrintAllCheckboxChange = (event) => {
    this.setState({printAllCB: !this.state.printAllCB});
  }
  onPrintProjectsCheckboxChange = (event) => {
    this.setState({printProjectsCB: !this.state.printProjectsCB});
  }

  onLanguageChange = (value) =>{
    this.setState({selectedLanguage: value});
  }

  onCalculationsClick = (event) => {
    this.setState({ calculationStatus: event.target.value });
  }

  isCalculationSelected = (value) => {
    return this.state.calculationStatus[value];
  }

  onCreatePdfHandler = (event) => {
    // console.log(this.state.selectedLanguage);
    // ga('send',
    //   {
    //     hitType: 'event',
    //     eventCategory: 'Calculus',
    //     eventAction: 'printPdf',
    //     eventLabel: this.state.selectedLanguage
    //   });

    adobeSavePDF();

    this.props.onCreatePdf({
      printLanguage: this.state.selectedLanguage,
      printName: this.state.nameCB,
      printNameValue: this.state.pdfName,
      printDate: this.state.dateCB,
      printDateValue: new Date().toLocaleDateString(),
      printTime: this.state.timeCB,
      printTimeValue: new Date().toLocaleTimeString(),
      printAll: this.state.printAllCB,
      printProjects: this.state.printProjectsCB,
      printCalculations: this.state.calculationStatus,
    });
    this.state.calculationStatus = [];
  }

  onCancelCreatePdfHandler = (event) => {
    adobeCancelSavePDF();
    this.state.calculationStatus = [];
    this.props.onCancelCreatePdf();
  }

  render() {
    const {app, project, user, translations, onCreatePdf, onCancelCreatePdf, ...other } = this.props;

    const {
      username,
    } = user;

    const {
      calculations,
      calculationIndex,
    } = project;

    if(calculations[calculationIndex] && this.state.calculationStatus.length == 0 && app.printPdfDialogOpen) {
      this.state.calculationStatus = [calculations[calculationIndex].name];
    }


    let ui = buildUIStringArray(app.language, translations.data);
    /*
    let languages=[
      {title:'English',value:'English'},
      {title:'Swedish',value:'Swedish'},
      {title:'Finnish',value:'Finnish'},
      {title:'German',value:'German'},
      {title:'Danish',value:'Danish'},
    ];
    */
    let languageList = languages.map( (item, index) => {
      return {name: item.language, id: item.language};
    });

    let calculationsList = calculations.map( (item)  => {
      return  (<MenuItem key={item.name}
                        value={item.name}
                        style={{ fontWeight: this.state.calculationStatus.indexOf(item.name) !== -1 ? 'bold' : 'normal', }}>
                {item.name}
              </MenuItem>);
    });

    return (
      <Dialog
        onClose={onCancelCreatePdf}
        fullWidth
        TransitionProps={{ onEnter: app.printPdfDialogOpen ? null : this.initLanguage(app.language) }}
        {...other}
      >
        <DialogTitle>{ui['PDF_DIALOG-TITLE']}</DialogTitle>
        <DialogContent>

          <Grid container spacing={0}>
            <Grid item xs={12} md={12} style={{marginBottom: 10 + 'px'}}>
              <DropDownList label={ui['PDF_DIALOG-LANGUAGE']} data={languageList} selectedItem={this.state.selectedLanguage} onChange={(value) => {this.onLanguageChange(value);}} />
            </Grid>

            <Grid item xs={12} md={6} >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.nameCB}
                    onClick={this.onNameCheckboxChange}
                  />
                }
                label={ui['PDF_DIALOG-INCLUDE_AUTHOR_NAME']}
                classes={{root: 'checkbox-form-control-label'}}
              />
            </Grid>
            <Grid item xs={12} md={6} >
              {/* <Input value={this.state.pdfName} disabled={!this.state.nameCB} onChange={(e) => {this.setState({"pdfName": e.currentTarget.value})}}/>*/}
              <InputComponent className="print-pdf-dialog-input-component" value={this.state.pdfName} disabled={!this.state.nameCB} type="string" onChange={(value) => {this.setState({'pdfName': value});}} />
            </Grid>

            <Grid item xs={12} >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.dateCB}
                    onClick={this.onDateCheckboxChange}
                  />
                }
                label={ui['PDF_DIALOG-INCLUDE_DATE']}
                classes={{root: 'checkbox-form-control-label'}}
              />
            </Grid>

            <Grid item xs={12} >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.timeCB}
                    onClick={this.onTimeCheckboxChange}
                  />
                }
                label={ui['PDF_DIALOG-INCLUDE_TIME']}
                classes={{root: 'checkbox-form-control-label'}}
              />
            </Grid>

            <Grid item xs={12} >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.printAllCB}
                    onClick={this.onPrintAllCheckboxChange}
                  />
                }
                label={ui['PDF_DIALOG-PRINT-ALL-CALCULATIONS']}
                classes={{root: 'checkbox-form-control-label'}}
              />
            </Grid>

            {username &&
              <Grid item xs={12} >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.printProjectsCB}
                      onClick={this.onPrintProjectsCheckboxChange}
                    />
                  }
                  label={ui['PDF_DIALOG-INCLUDE_PROJECT_INFO']}
                  classes={{root: 'checkbox-form-control-label'}}
                />
              </Grid>
            }


            {/*
            <Grid item xs={12} md={12}>
              <List disablePadding="true">
                <ListItem onClick={this.onNameCheckboxChange}>
                  <Checkbox checked={this.state.nameCB} />
                  <ListItemText primary= />
                  <ListItemSecondaryAction>
                    <Input value={this.state.pdfName} disabled={!this.state.nameCB} onChange={(e) => {this.setState({"pdfName": e.currentTarget.value})}}/>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
              <List disablePadding="true">
                <ListItem onClick={this.onDateCheckboxChange}>
                  <Checkbox checked={this.state.dateCB} />
                  <ListItemText primary={ui['PDF_DIALOG-INCLUDE_DATE']} />
                  <ListItemSecondaryAction>
                    <Input value={this.state.pdfDate} disabled={!this.state.dateCB} onChange={(e) => {this.setState({"pdfDate": e.currentTarget.value})}}/>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
              <List disablePadding="true">
                <ListItem onClick={this.onTimeCheckboxChange}>
                  <Checkbox checked={this.state.timeCB} />
                  <ListItemText primary={ui['PDF_DIALOG-INCLUDE_TIME']} />
                  <ListItemSecondaryAction>
                    <Input value={this.state.pdfTime} disabled={!this.state.timeCB} onChange={(e) => {this.setState({"pdfTime": e.currentTarget.value})}}/>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
              <List disablePadding="true">
                <ListItem onClick={this.onPrintAllCheckboxChange}>
                  <Checkbox checked={this.state.printAllCB} />
                  <ListItemText primary={ui['PDF_DIALOG-PRINT-ALL-CALCULATIONS']} />
                </ListItem>
              </List>
            </Grid>
            */}
            <Grid item xs={12} md={12}>
              <InputLabel htmlFor="uncontrolled-native">{ui['PDF_DIALOG-SELECT_PRINTABLE_TARGETS']}</InputLabel><br/>
              <Select multiple value={this.state.calculationStatus} onChange={this.onCalculationsClick} disabled={this.state.printAllCB}
                      input={<Input id="name-multiple" />}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 48 * 4.5 + 8,
                            width: 200,
                          },
                        },
                      }}
                      >
                {calculationsList}
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onCancelCreatePdfHandler} color="primary">
            {ui['GENERAL-CANCEL']}
          </Button>
          <Button onClick={this.onCreatePdfHandler} color="primary" autoFocus>
            {ui['GENERAL-SAVE']}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PrintPdfDialog.propTypes = {
    app: PropTypes.object,
    project: PropTypes.object,
    translations: PropTypes.object,
    user: PropTypes.object,
  onCreatePdf: PropTypes.any,
  onCancelCreatePdf: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      app: state.app,
      project: state.project,
      translations: state.translations,
      user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCancelCreatePdf: index => dispatch(pdfCreateCancel()),
      onCreatePdf: values => dispatch(pdfCreate(values)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PrintPdfDialog);
